export default "__VITE_ASSET__5302ee1b__"